import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { logOut } from 'actions/authentication';
import { closeDrawer } from 'store/reducers/ui';

const DISPLAY_REPORT_PAGE = false;

export default function NavbarItems({ isMobile }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;
  const { uuid: adminUuid } = useSelector((state) => state.adminUser);
  const {
    isAdmin,
    providerUsers,
    token,
    uuid: currentUserUuid,
  } = useSelector((state) => state.user);
  const isImpersonating = adminUuid && currentUserUuid !== adminUuid;

  const loggedOutItems = [
    {
      to: '/login',
      text: 'Login',
    },
    {
      to: '/signup',
      text: 'Sign up',
    },
  ];

  const loggedInItems = [
    {
      to: '/today',
      text: 'Today',
    },
    {
      to: '/appointments',
      text: 'Appointments',
    },
    {
      to: '/team',
      text: 'Team',
    },
    {
      to: '/clients/1',
      text: 'Clients',
    },
    providerUsers?.role?.id === 1
      ? {
          to: '/payment-history/1',
          text: 'Payment history',
        }
      : null,
    DISPLAY_REPORT_PAGE
      ? {
          to: '/report',
          text: 'Report',
        }
      : null,
    {
      to: '/services',
      text: 'Profile',
    },
    isAdmin &&
      !isImpersonating && {
        to: '/search-provider',
        text: 'Search',
      },
    isAdmin &&
      !isImpersonating && {
        to: '/admin/_signup',
        text: 'Admin',
      },
  ];

  const items = token ? loggedInItems : loggedOutItems;

  const closeNavbarDrawer = () => {
    dispatch(closeDrawer());
  };

  return (
    <>
      {items.filter(Boolean).map(({ to, text }) => (
        <Link
          key={to}
          to={to}
          className={classNames(
            'text-left c-secondary-purple f15 fw-400 pointer',
            pathname.includes(to) && 'active'
          )}
          onClick={closeNavbarDrawer}
        >
          {text}
        </Link>
      ))}
      {token ? (
        <button
          onClick={() => logOut('/')}
          className={classNames(
            'pointer no-style-btn f15 c-secondary-purple text-left fw-400 ',
            !isMobile && 'pos-absolute navbar-items-logout'
          )}
        >
          Log out
        </button>
      ) : null}
    </>
  );
}
